import { ActivityType, ActorType } from 'src/generated/mloop-graphql';

export enum ActivityFeedTabs {
  All = 'all_activity',
  Comments = 'comments_only',
  CandidateAction = 'candidate_actions_only',
}

export const getActivityTypesForActivityFeedTab = (currentTab: ActivityFeedTabs): ActivityType[] => {
  if (currentTab === ActivityFeedTabs.Comments) {
    return [ActivityType.Note];
  }

  return [];
};

export const getActorTypesForActivityFeedTab = (currentTab: ActivityFeedTabs): ActorType[] | undefined => {
  if (currentTab === ActivityFeedTabs.CandidateAction) {
    return [ActorType.Candidate];
  }

  return undefined;
};
